import { FoodDrumstickOffIcon } from './FoodDrumstickOffIcon';

/**
 * author: Michael Irigoyen
 * id BC4982E1-86E2-48A1-AE1B-8FD95D6BA850
 * name food-drumstick-off
 * version: 5.2.45
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/food-drumstick-off.svg
 * tags
 * - Food / Drink 
 */
export const TurkeyLegOffIcon = FoodDrumstickOffIcon;
export default TurkeyLegOffIcon